import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import Icon from '../../components/icons.jsx'

export default function ProjectEditPopover({ anchorRef, title, busy, onClose, children }) {
  const ref = useRef(null)
  const [position, setPosition] = useState({ top: 0, left: 0 })
  useLayoutEffect(() => {
    const place = () => {
      const anchor = anchorRef.current?.getBoundingClientRect()
      const popup = ref.current?.getBoundingClientRect()
      if (!anchor || !popup) return
      const left = Math.max(8, Math.min(anchor.left, window.innerWidth - popup.width - 8))
      const below = anchor.bottom + 8
      const top = below + popup.height <= window.innerHeight - 8 ? below : Math.max(8, anchor.top - popup.height - 8)
      setPosition(previous => previous.top === top && previous.left === left ? previous : { top, left })
    }
    const outside = e => {
      if (!busy && !ref.current?.contains(e.target) && !anchorRef.current?.contains(e.target)) onClose()
    }
    place()
    const observer = new ResizeObserver(place)
    if (ref.current) observer.observe(ref.current)
    window.addEventListener('resize', place)
    window.addEventListener('scroll', place, true)
    document.addEventListener('pointerdown', outside, true)
    return () => {
      observer.disconnect()
      window.removeEventListener('resize', place)
      window.removeEventListener('scroll', place, true)
      document.removeEventListener('pointerdown', outside, true)
    }
  }, [anchorRef, busy, onClose])
  return createPortal(<section ref={ref} className="op-edit-popover" style={position} role="dialog" aria-label={title} onKeyDown={e => {
    if (e.key === 'Escape' && !busy) { e.preventDefault(); e.stopPropagation(); onClose() }
  }}>
    <header><strong>{title}</strong><button type="button" aria-label="Fechar edição" disabled={busy} onClick={onClose}><Icon n="x" s={15} /></button></header>
    {children}
  </section>, document.body)
}
